import { ConfirmationDialog } from './../../common/confirmation-dialog/confirmation-dialog.component';
import { Router } from '@angular/router';
import { AlertDialog } from './../../common/alert-dialog/alert-dialog.component';
import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';
import { Component, isDevMode, OnInit } from '@angular/core';
import { Shipment, ShipmentService, UnreceivedWarehouseTransfersDetail } from 'src/app/acumatica/EntityServices/Shipment.service';
import { PurchaseReceiptService, PurchaseReceipt } from 'src/app/acumatica/EntityServices/PurchaseReceipt.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sales-rep-receipt',
  templateUrl: './sales-rep-receipt.component.html',
  styleUrls: ['./sales-rep-receipt.component.css']
})
export class SalesRepReceiptComponent implements OnInit {
  shipmentNbr: string = '';
  receipt?: PurchaseReceipt;
  unreceivedShipments?: UnreceivedWarehouseTransfersDetail[];

  shipmentDocs: { [key: string]: Shipment } = {};

  constructor(
    private mayerfabrics: MayerFabricsService,
    private shipments: ShipmentService,
    private receipts: PurchaseReceiptService,
    private dialog: MatDialog,
    private router: Router
  ) {
    let whseID = this.mayerfabrics.RepWarehouseID;
    if (!whseID) { this.router.navigate(['/']); return }

    this.shipments.getSalesRepUnreceivedShipments(whseID)
      .subscribe(shipments => {
        this.unreceivedShipments = shipments;
      });
  }

  ngOnInit(): void {
  }

  keyedReceiveShipment() {
    this.receiveShipment(this.shipmentNbr).then(() => {
      this.shipmentNbr = '';
    })
  }

  clickReceiveShipment(shipmentNbr: string) {
    this.dialog.open(ConfirmationDialog, {
      data: {
        icon: 'help',
        message: "Are you sure you're ready to mark Shipment " + shipmentNbr + " as Received and adjust the shipped items into your Warehouse Inventory?",
        confirmText: 'Yes, it\'s Received',
        cancelText: 'Cancel'
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        this.receiveShipment(shipmentNbr).then(() => {
          // remove the received shipment from the list of unreceived shipments
          let doc = this.unreceivedShipments!.find(shipment => shipment.ShipmentNbr == shipmentNbr);
          this.unreceivedShipments!.remove(doc);
        });
      }
    })
  }

  receiveShipment(shipmentNbr: string): Promise<void> {
    return new Promise<void>(done => {
      if (!shipmentNbr) { done(); return; }

      this.shipments.get(shipmentNbr, { loader: "Getting Shipment Details" }).subscribe(shipment => {
        if (shipment.ToWarehouseID != this.mayerfabrics.RepWarehouseID || shipment.Type != 'Transfer')
          throw new Error("The provided Shipment Number does not appear to be a valid Transfer Shipment to you.");

        let receipt = new PurchaseReceipt({
          Type: 'Transfer Receipt',
          Warehouse: this.mayerfabrics.RepWarehouseID
        });

        this.receipts.put(receipt, { loader: "Creating Receipt" }).subscribe(createdReceipt => {
          this.receipts.ReceiveWhseTransferShipment(createdReceipt, shipmentNbr, {
            message: "Adding Shipment to Receipt"
          }).subscribe(fullReceipt => {
            this.shipmentNbr = shipmentNbr;
            this.receipt = fullReceipt;

            this.dialog.open(AlertDialog, {
              data: {
                message: "Your Receipt has been Completed. Inventory has been Updated",
                buttonText: 'Ok'
              }
            }).afterClosed().subscribe(() => {
              done();
            });
          })
        });
      });
    });
  }

  loadShipment(shipmentNbr: string) {
    if (this.shipmentDocs[shipmentNbr]) return;

    this.shipments.get(shipmentNbr, { expand: ['Details', 'Packages'], loader: null }).subscribe(shipment => {
      this.shipmentDocs[shipmentNbr] = shipment;
    })
  }

  trackShipment(shipmentNbr: string) {
    let shipment = this.shipmentDocs[shipmentNbr];
    if (!shipment) return;

    let trackingNbrs = shipment.Packages?.map(pckg => pckg.TrackingNbr).join(",");

    if (!trackingNbrs) {
      this.dialog.open(AlertDialog, { data: { message: "There are no Tracking #s available for this Shipment", buttonText: 'OK' } });
      return;
    }

    let url = "https://app.mayerfabrics.com/upstrack/?t=" + trackingNbrs;

    window.open(url, '_blank');
  }
}
